var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-wrapper"},[_vm._t("default"),(_vm.showBtn)?_c('div',{staticClass:"card-btn-box"},[_c('van-button',{staticClass:"btn",on:{"click":_vm.changeStep}},[_vm._v(_vm._s(_vm.btnMsg))])],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }